module.exports = __webpack_public_path__ + "static/img/leaf.55c9f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/leaf.png
// module id = LrTL
// module chunks = 0